document.addEventListener('DOMContentLoaded', function () {
    const scene = document.querySelector('a-scene#main-scene');
    let isMouseDown = false;
    let lastMouseX = 0;
    let lastMouseY = 0;
    let isRotationLocked = false;
    let rotationLockAxis = null;
    let dragStartX = 0;
    let dragStartY = 0;
    const LOCK_THRESHOLD = 5;
    let stockCubeWrapper = null;
    let camera = null;
    let isRightMouseDown = false;
    let lastRightMouseX = 0;
    let lastRightMouseY = 0;
    let isPinching = false;
    let lastPinchDistance = 0;
    const defaultCameraPosition = { x: 0, y: 2.75, z: 2 };
    let mainAction = 'rotate'
    let isVRDevice = false


    const shouldEnableMouseControls = () => {
        const isMmapActive = document?.body?.classList?.contains('mmap-graph');
        if (!isMmapActive) {
            return true;
        }
        return true;
    };

    const shouldEnableRotationControls = () => {
        if (window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) {
            return true;
        }
        const isMmapActive = document?.body?.classList?.contains('mmap-graph');
        if (isMmapActive) {
            try {
                const mmapMode = typeof getCacheItem !== 'undefined' ? getCacheItem('mmap_view_mode') : null;
                return mmapMode === '3d';
            } catch (e) { return false; }
        }
        return true;
    };

    const isTouchInteractionBlocked = () =>
        (window.matchMedia('(any-pointer: coarse)').matches ||
            window.matchMedia('(pointer: coarse)').matches ||
            navigator.maxTouchPoints > 0) &&
        window.StockStorm3DInteraction &&
        !window.StockStorm3DInteraction.isEnabled() &&
        !document.body.classList.contains('chart-fullscreen');

    scene.addEventListener('loaded', function () {
        camera = document.querySelector('#camera');
        setupMouseControls();
        setupVRDeviceControlSwitcher();
        const sceneEl = document.querySelector('a-scene');
        if (sceneEl) {
            sceneEl.addEventListener('update-billboards', updateBillboards)
        }
        adjustmentForScrollingScreens();
    });

    function setupMouseControls() {
        const canvas = scene.canvas;

        canvas.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        });

        function getPinchDistance(touches) {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.hypot(dx, dy);
        }

        function applyCameraZoom(zoomDelta) {
            if (!camera) {
                return;
            }
            const currentPosition = camera.getAttribute('position');
            const newZ = currentPosition.z + zoomDelta;
            const minZ = 0.2;
            const maxZ = 5.0;
            const clampedZ = Math.max(minZ, Math.min(maxZ, newZ));
            camera.setAttribute('position', {
                x: currentPosition.x,
                y: currentPosition.y,
                z: clampedZ
            });
        }

        function resetGestureState() {
            isMouseDown = false;
            isRightMouseDown = false;
            isPinching = false;
            lastPinchDistance = 0;
            isRotationLocked = false;
            rotationLockAxis = null;
            canvas.style.cursor = shouldEnableRotationControls() ? 'grab' : 'default';
        }

        if (window.StockStorm3DInteraction) {
            window.StockStorm3DInteraction.resetGestureState = resetGestureState;
            window.StockStorm3DInteraction.setMainAction = (action) => {
                if (action === 'rotate' || action === 'move') {
                    mainAction = action;
                }
            };
            const initialAction = window.StockStorm3DInteraction.getMainAction?.();
            if (initialAction === 'rotate' || initialAction === 'move') {
                mainAction = initialAction;
            }
        }

        function handleDown(event) {
            const isTouch = event.type.startsWith('touch');

            if (isTouch && isTouchInteractionBlocked()) {
                resetGestureState();
                return;
            }

            if (isTouch && event.touches.length === 2) {
                if (!shouldEnableMouseControls()) {
                    return;
                }
                if (window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) {
                    return;
                }
                isPinching = true;
                isMouseDown = false;
                isRightMouseDown = false;
                isRotationLocked = false;
                rotationLockAxis = null;
                lastPinchDistance = getPinchDistance(event.touches);
                if (event.cancelable) event.preventDefault();
                return;
            }
            const button = isTouch ? 0 : event.button;
            const clientX = isTouch ? event.touches[0].clientX : event.clientX;
            const clientY = isTouch ? event.touches[0].clientY : event.clientY;
            const shouldEnableRotationControlsValue = shouldEnableRotationControls()  
            const mainButtonIndex = mainAction === 'rotate' ? 0 : 2
            const secondaryButtonIndex = mainAction === 'move' ? 0 : 2

            if (button === mainButtonIndex) { // Left mouse button
                if (shouldEnableRotationControlsValue) {
                    isMouseDown = true;
                    lastMouseX = clientX;
                    lastMouseY = clientY;
                    dragStartX = clientX;
                    dragStartY = clientY;
                    isRotationLocked = false;
                    rotationLockAxis = null;
                    canvas.style.cursor = 'grabbing';
                }
            } 
            if (button === secondaryButtonIndex || ((isVRDevice || isTouch) && !shouldEnableRotationControlsValue)) { // Right mouse button
                if (!isTouch) event.preventDefault();
                isRightMouseDown = true;
                lastRightMouseX = clientX;
                lastRightMouseY = clientY;
                canvas.style.cursor = 'move';
            }

            if (window.gtag) gtag('event', `Desktop_CenterPanel_ChartRotation`);
        }

        canvas.addEventListener('touchstart', handleDown, { passive: false });
        canvas.addEventListener('mousedown', handleDown);

        function handleMove(event) {
            const isTouch = event.type.startsWith('touch');

            if (isTouch && isTouchInteractionBlocked()) {
                resetGestureState();
                return;
            }

            if (isTouch && isPinching && event.touches.length === 2) {
                if (event.cancelable) event.preventDefault();
                const newDistance = getPinchDistance(event.touches);
                const delta = newDistance - lastPinchDistance;
                lastPinchDistance = newDistance;
                
                if (window.MobileNav && window.MobileNav.isDetailActive && window.MobileNav.isDetailActive()) {
                    if (delta < -10) {
                        window.MobileNav.closeStockDetail();
                    }
                    return;
                }

                const pinchZoomSpeed = 0.01;
                applyCameraZoom(-delta * pinchZoomSpeed);
                return;
            }

            const clientX = isTouch ? event.touches[0].clientX : event.clientX;
            const clientY = isTouch ? event.touches[0].clientY : event.clientY;

            if (isRightMouseDown && camera) {
                if (window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) return;
                if (isTouch && event.cancelable) event.preventDefault();
                const deltaX = clientX - lastRightMouseX;
                const deltaY = clientY - lastRightMouseY;

                const currentPosition = camera.getAttribute('position');
                const panSpeed = 0.003 * (currentPosition.z || 1);

                camera.setAttribute('position', {
                    x: currentPosition.x - deltaX * panSpeed,
                    y: currentPosition.y + deltaY * panSpeed,
                    z: currentPosition.z
                });

                lastRightMouseX = clientX;
                lastRightMouseY = clientY;
                return;
            }

            if (!shouldEnableRotationControls()) {
                isMouseDown = false;
                canvas.style.cursor = 'default';
                return;
            }

            if (!isMouseDown) {
                canvas.style.cursor = 'grab';
            }

            stockCubeWrapper = document.querySelector('#stock-3d-cube-wrapper');
            if (isMouseDown && stockCubeWrapper) {
                if (isTouch && event.cancelable) event.preventDefault();

                var buildingsActive = window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive();
                if (buildingsActive) {
                    isRotationLocked = true;
                    rotationLockAxis = 'x'; // 'x' axis lock = Y-axis world rotation
                }

                if (!isRotationLocked) {
                    const diffX = Math.abs(clientX - dragStartX);
                    const diffY = Math.abs(clientY - dragStartY);

                    if (diffX > LOCK_THRESHOLD || diffY > LOCK_THRESHOLD) {
                        isRotationLocked = true;
                        rotationLockAxis = diffX > diffY ? 'x' : 'y';
                    } else {
                        return;
                    }
                }

                const deltaX = (clientX - lastMouseX) * 0.01; // rad
                const deltaY = (clientY - lastMouseY) * 0.01; // rad

                // 1. Get current quaternion
                const currentQuat = stockCubeWrapper.object3D.quaternion.clone();

                // 2. Create delta rotations in World Space
                let quatX = new AFRAME.THREE.Quaternion();
                let quatY = new AFRAME.THREE.Quaternion();

                if (rotationLockAxis === 'y') {
                    quatX.setFromAxisAngle(
                        new AFRAME.THREE.Vector3(1, 0, 0),
                        deltaY
                    );
                } else if (rotationLockAxis === 'x') {
                    quatY.setFromAxisAngle(
                        new AFRAME.THREE.Vector3(0, 1, 0),
                        deltaX
                    );
                }

                // 3. Combine: premultiply delta rotations to apply them in "Global/Screen" space
                const newQuat = quatY.multiply(quatX).multiply(currentQuat);

                // 4. Update object
                stockCubeWrapper.object3D.quaternion.copy(newQuat);

                const rotation = stockCubeWrapper.getAttribute('rotation');
                scene.emit('update-rotation', rotation);

                lastMouseX = clientX;
                lastMouseY = clientY;
            }
        }

        canvas.addEventListener('touchmove', handleMove, { passive: false });
        canvas.addEventListener('mousemove', handleMove);

        function handleUp(event) {
            const isTouch = event.type.startsWith('touch');

            if (isPinching) {
                const remainingTouches = isTouch && event.touches ? event.touches.length : 0;
                if (remainingTouches < 2) {
                    isPinching = false;
                    lastPinchDistance = 0;
                    isMouseDown = false;
                    isRotationLocked = false;
                    rotationLockAxis = null;
                }
                return;
            }

            const button = isTouch ? 0 : event.button;
            const shouldEnableRotationControlsValue = shouldEnableRotationControls()
            const mainButtonIndex = mainAction === 'rotate' ? 0 : 2
            const secondaryButtonIndex = mainAction === 'move' ? 0 : 2

            if (button === mainButtonIndex) { // Left mouse button
                isMouseDown = false;
                isRotationLocked = false;
                rotationLockAxis = null;
                canvas.style.cursor = shouldEnableRotationControlsValue ? 'grab' : 'default';
                updateBillboards();
            } 
            if (button === secondaryButtonIndex || (isVRDevice && !shouldEnableRotationControlsValue)) { // Right mouse button
                isRightMouseDown = false;
                canvas.style.cursor = shouldEnableRotationControlsValue ? 'grab' : 'default';
            }
        }

        canvas.addEventListener('touchend', handleUp);
        canvas.addEventListener('touchcancel', handleUp);
        canvas.addEventListener('mouseup', handleUp);

        canvas.addEventListener('mouseleave', function () {
            isMouseDown = false;
            isRightMouseDown = false;
            isRotationLocked = false;
            rotationLockAxis = null;
            canvas.style.cursor = shouldEnableRotationControls() ? 'grab' : 'default';
        });

        canvas.addEventListener('wheel', function (event) {
            if (!shouldEnableMouseControls()) {
                return;
            }
            if (window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) return;
            if (window._mmapBuildingsExitTime && (Date.now() - window._mmapBuildingsExitTime) < 250) return;

            event.preventDefault();

            if (camera) {
                const currentPosition = camera.getAttribute('position');
                const zoomSpeed = 0.2;
                const zoomDirection = event.deltaY > 0 ? 1 : -1;

                const newZ = currentPosition.z + (zoomDirection * zoomSpeed);

                const minZ = 0.2;
                const maxZ = 5.0;
                const clampedZ = Math.max(minZ, Math.min(maxZ, newZ));

                camera.setAttribute('position', {
                    x: currentPosition.x,
                    y: currentPosition.y,
                    z: clampedZ
                });
            }
        });

        canvas.style.cursor = shouldEnableRotationControls() ? 'grab' : 'default';

        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    const wasMMActive = mutation.oldValue && mutation.oldValue.includes('mmap-graph');
                    const isMMActive = document.body.classList.contains('mmap-graph');
                    const wasWLActive = mutation.oldValue && mutation.oldValue.includes('watchlist-mode');
                    const isWLActive = document.body.classList.contains('watchlist-mode');

                    if ((wasMMActive && !isMMActive) || (wasWLActive && !isWLActive)) {
                        if (camera) {
                            const currentPosition = camera.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
                            camera.setAttribute('position', {
                                x: 0,
                                y: 2.75,
                                z: currentPosition.z
                            });
                        }
                    }
                }
            });
        });
        observer.observe(document.body, { attributes: true, attributeOldValue: true });
    }
    
    function setupVRDeviceControlSwitcher() {
        if (!window.AppState || !window.AppState.isTrueVRMode) return
        isVRDevice = true
        
        const mainActionSwitcher = document.querySelector('#main-block .chart-wrapper .rotate-move-switcher-container:not(.marketmap-move-zoom-switcher-container)')
        if (!mainActionSwitcher) return
        
        const observer = new MutationObserver(() => {
             if (document.body.classList.contains('mmap-graph')) {
                 mainActionSwitcher.classList.add('force-hide')
             } else {
                 mainActionSwitcher.classList.remove('force-hide')
             }
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
        
        if (document.body.classList.contains('mmap-graph')) {
             mainActionSwitcher.classList.add('force-hide')
        }

        mainActionSwitcher.classList.add('show-vr')
        mainActionSwitcher.addEventListener('click', () => {
            mainActionSwitcher.classList.toggle('mode-move')
            mainAction = mainAction === 'rotate' ? 'move' : 'rotate'
        })
    }

    function updateBillboards() {
        camera = document.querySelector('#camera');

        const currentCameraPosition = new AFRAME.THREE.Vector3();
        camera.object3D.getWorldPosition(currentCameraPosition);

        const fullBillboards = document.querySelectorAll('.billboard')
        const xBillboards = document.querySelectorAll('.billboard-x')
        const yBillboards = document.querySelectorAll('.billboard-y')


        fullBillboards.forEach(el => {
            if (el.object3D) {
                const adjustedPosition = currentCameraPosition.clone();
                adjustedPosition.y -= 0.3;
                el.object3D.lookAt(adjustedPosition);
            }
        });

        xBillboards.forEach(el => {
            if (el.object3D) {
                const objectWorldPos = new AFRAME.THREE.Vector3();
                el.object3D.getWorldPosition(objectWorldPos);

                const direction = currentCameraPosition.clone().sub(objectWorldPos);
                const currentRotation = el.object3D.rotation;
                const targetX = Math.atan2(direction.z, direction.y) - Math.PI / 2;
                el.object3D.rotation.set(targetX, currentRotation.y, currentRotation.z);
            }
        });

        yBillboards.forEach(el => {
            if (el.object3D) {
                const objectWorldPos = new AFRAME.THREE.Vector3();
                el.object3D.getWorldPosition(objectWorldPos);

                const direction = currentCameraPosition.clone().sub(objectWorldPos);
                const currentRotation = el.object3D.rotation;
                const targetY = Math.atan2(direction.x, direction.z);
                el.object3D.rotation.set(currentRotation.x, targetY, currentRotation.z);
            }
        });
    }


    function adjustmentForScrollingScreens() {
        const contentRow = document.querySelector('#main-block .content-row');
        if (contentRow) {
            contentRow.addEventListener('scroll', function () {
                window.dispatchEvent(new Event('resize'));
            });
        }
        
        const chartTypeButtons = document.querySelectorAll('#main-block .filters-container .item');

        chartTypeButtons.forEach(button => {
            button.addEventListener('click', function () {
                setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
            });
        })
    }
});
